import { useEffect, useState } from "react";

// project import
import Routes from "routes";
import ThemeCustomization from "themes";

import Loader from "components/Loader";
import Locales from "components/Locales";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";

import { dispatch } from "store";
import { fetchMenu } from "store/reducers/menu";

// auth-provider
import { JWTProvider as AuthProvider } from "contexts/JWTContext";
import Cookies from "js-cookie";
import { encrypt, decrypt, getCookie, setEncryptedItem, getDomainName } from "utils/commonFunctions";
import { useLocation } from "react-router";
import useConfig from "hooks/useConfig";
// import Unauthorized from "pages/maintenance/unautorized";
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
declare var $: any;
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
const domain = getDomainName();
const isIONetgateDomain = domain.includes('io-netgate');
const isIOMDomain = domain.includes('io-market');

const App = () => {

  const [loading, setLoading] = useState<boolean>(true);
  // const [accessGranted, setAccessGranted] = useState<boolean>(false);
  // const [invoiceUrl, setInvoiceUrl] = useState<string | undefined>('');
  const location = useLocation();
  const { mode } = useConfig();
  useEffect(() => {
    mode=='light' ? localStorage.setItem('sm-skin','smart-style-2') : localStorage.setItem('sm-skin','smart-style-1')
    mode=='light' ?  $('body').removeClass('smart-style-1') : $('body').removeClass('smart-style-2');
    mode=='light' ?  $('body').addClass('smart-style-2') : $('body').addClass('smart-style-1');
    // fetch dashboard menu from API
    if(isIOMDomain){
      let cookieExist = Cookies.get(process.env.REACT_APP_EXPIRE_COOKIE || "");
      const expireCookie: any = getCookie(
        process.env.REACT_APP_EXPIRE_COOKIE || ""
      );
      const userExpireData = decodeURIComponent(expireCookie);
      if(userExpireData) {
        const userDetails = JSON.parse(decrypt(userExpireData));
        setEncryptedItem('partyID',userDetails['partyID']);
        setEncryptedItem('userID',userDetails['userID']);
        setEncryptedItem('accId',userDetails['accId']);
      }
      const host = window.location.host;
      const parts = host.split(".");
      parts.shift();
      let domain = parts.join('.')
      console.log('domain...' + domain);
      if (!cookieExist) {
        const externalUrl =
          `${process.env.REACT_APP_ACCOUNT_LOGIN
          }${domain}/#/auth/logout/${encodeURIComponent(encrypt(window.location.href))}` ||
          "/";
        window.location.assign(externalUrl);
      }
    }else if (isIONetgateDomain) {
        let instanceCookie = Cookies.get(process.env.REACT_APP_INSTANCE_COOKIE || "");
        let loginCookie = Cookies.get(process.env.REACT_APP_LOGIN_COOKIE || "");
        const REDIRECT_LOGIN_ARRAY = process.env.REACT_APP_REDIRECT_NETGATE_LOGIN ? JSON.parse(process.env.REACT_APP_REDIRECT_NETGATE_LOGIN ) : undefined ;
        const INSTANCE_COOKIE = instanceCookie ? JSON.parse(decrypt(instanceCookie)) : undefined;

        const INVOICE_URL = INSTANCE_COOKIE ?
            REDIRECT_LOGIN_ARRAY.find((item: any) => item[INSTANCE_COOKIE['instance']])[INSTANCE_COOKIE['instance']] : '';
            console.log("INVOICE_URL :",INVOICE_URL);
            
        if (loginCookie && INSTANCE_COOKIE) {
          localStorage.setItem('redirectUrl',INVOICE_URL);
        //     setEncryptedItem('partyID', userDetails['partyID']);
        //     setEncryptedItem('userID', userDetails['userID']);
        //     setEncryptedItem('accId', userDetails['accId']);
        } 
        // } else {
            // setAccessGranted(false);
            // setInvoiceUrl(INVOICE_URL);
        // }
    }

    // if(!accessGranted && isIONetgateDomain && invoiceUrl){
    //   return (<Unauthorized redirectUrl={invoiceUrl} />)
    // }

    if (location.pathname.includes("/login")) {
      window.location.assign("/");
    }
    dispatch(fetchMenu()).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <Loader />;

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <>
                <Notistack>
                  <Routes />
                  <Snackbar />
                </Notistack>
              </>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;